import request from '@/util/request';

//住户信息
export const loadZhxx = (params, options) =>
  request.get(
    '/api/propertyCharges/household/getHouseholdByCodeOrId/v2',
    Object.assign({}, options, {
      params
    })
  );
//欠费信息
export const loadQfxx = (params, options) =>
  request.get('/api/propertyCharges/arrearages/collect/v2', Object.assign({}, options, {
    params
  }));
//账单明细
export const loadBill = (params, options) =>
  request.get('/api/propertyCharges/feeBill/list/v2', Object.assign({}, options, {
    params
  }));
//更新账单明细优惠
export const updateBill = (params, options) =>
  request.post('/api/propertyCharges/feeBill/updateById/v2', params, options);
//预收费-费项
export const loadPrePayItem = (params, options) =>
  request.get('/api/propertycharges/prepay/itemset/list/v2', Object.assign({}, options, {
    params
  }));
//预收费-收费周期
export const loadPrePayStartCycle = (params, options) =>
  request.get('/api/propertycharges/prepay/startCycleV2/v2', Object.assign({}, options, {
    params
  }));
//预收费-优惠政策
export const loadPrePayPreferent = (params, options) =>
  request.get('/api/fee/feeitemsetpreferent/listforprepay/v2', Object.assign({}, options, {
    params
  }));
//预收费-收费金额
export const loadPrePayAmount = (params, options) =>
  request.get('/api/propertycharges/prepay/amount/v2', Object.assign({}, options, {
    params
  }));
//车辆收费-停车场下拉框
export const loadCarPayPark = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/parkSpaceTree/v2', Object.assign({}, options, {
    params
  }));
//车辆收费-欠费
export const loadCarPayBackAmount = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/carBackAmount/v2', Object.assign({}, options, {
    params
  }));
//车辆收费-月卡车下拉框
export const loadCarPayMonthCarNo = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/carMonthList/v2', Object.assign({}, options, {
    params
  }));
//车辆收费-开始时间
export const loadCarPayMonthCarStartTime = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/carMonthStartTime/v2', Object.assign({}, options, {
    params
  }));
//车辆收费-收费金额
export const loadCarPayAmount = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/getPayMoney/v2', Object.assign({}, options, {
    params
  }));
//车辆收费-欠费清单
export const loadCarPayBill = (params, options) =>
  request.get(
    '/api/v4ward/car/CarMonth/unPayMoneyByTempList/v2',
    Object.assign({}, options, {
      params
    })
  );
//临时收费-费项
export const loadTemporaryPayItem = (params, options) =>
  request.get('/api/propertycharges/temppay/itemset/list/v2', Object.assign({}, options, {
    params
  }));
//临时收费-优惠政策
export const loadTemporaryPayPreferent = (params, options) =>
  request.get(
    '/api/fee/feeitemsetpreferent/loaddefinepreferent/v2',
    Object.assign({}, options, {
      params
    })
  );
//临时收费-收费金额
export const loadTemporaryPayAmount = (params, options) =>
  request.get('/api/propertycharges/temppay/amount/v2', Object.assign({}, options, {
    params
  }));
//优惠政策
export const loadYhzc = (params, options) =>
  request.get('/api/propertycharges/preferent/list/v2', Object.assign({}, options, {
    params
  }));
//积分余额
export const loadJfye = (params, options) =>
  request.get(
    '/api/propertyCharges/integralBalance/loadpointaccount/v2',
    Object.assign({}, options, {
      params
    })
  );
//积分兑换
export const updateJfye = (params, options) =>
  request.post('/api/propertyCharges/integralBalance/integralExchange/v2', params, options);
//获取缴费人员id和缴费账户余额
export const loadAccountAmount = (params, options) =>
  request.get('/api/propertyCharges/household/payManInfo/v2', Object.assign({}, options, {
    params
  }));
//入账
export const saveAllBill = (params, options) =>
  request.post('/api/propertyCharges/paySuccess/save/v2', params, options);
//二维码支付
export const saveQrCodePay = (params, options) =>
  request.post('/api/propertyCharges/pay/qrCodePay/v2', params, options);
//条形码支付
export const saveBarCodePay = (params, options) =>
  request.post('/api/propertyCharges/pay/barCodePay/v2', params, options);
//查询支付状态
export const loadPayStatus = (params, options) =>
  request.get('/api/propertyCharges/pay/qrCodePayStatus/v2', Object.assign({}, options, {
    params
  }));
//票据打印预览
export const billPrintPerv = (params, options) =>
  request.get('/api/propertycharges/billprint/loadpayment/v2', Object.assign({}, options, {
    params
  }));
//票据打印保存
export const billPrintSave = (params, options) =>
  request.post('/api/propertycharges/billprint/save/v2', Object.assign(params, options));
//票据打印-打印
export const billPrint = (params, options) =>
  request.post('/api/propertycharges/billprint/update/v2', Object.assign(params, options));
//票据号检测
export const checkPayBillNo = (params, options) =>
  request.post('/api/propertycharges/billprint/checkPayBillNo/v2', Object.assign(params, options));

//收款方式
// export const payType = (params, options) =>
//   request.get(
//     '/api/blade-system/dict/dictionary?code=charge_pay_type',
//     Object.assign({}, options, { params })
//   );
//收款方式-加入现金支付权限控制
export const payType = (params, options) =>
  request.get(
    '/api/propertyCharges/pay/paylist/v2',
    Object.assign({}, options, {
      params
    })
  );

//划扣账单状态
export const bankBillStatus = (params, options) =>
  request.get(
    '/api/blade-system/dict/dictionary?code=bank_bill_status',
    Object.assign({}, options, {
      params
    })
  );
//二维码支付
export const saveQrCodePay_ = (params, options) =>
  request.post('/api/v4ward/propertypay/v1/qrCodePay/v2', params, options);

//划扣账单状态
export const getBillPayCalculateList = (params, options) =>
  request.get(
    '/api/v4ward/propertypay/v1/feeBillWithPreferent/list/v2',
    Object.assign({}, options, {
      params
    })
  );
